import {ACTION} from './actions.js'

const FIELDS = {
  MESSAGE: {
    NAME: 'message',
    LABEL: 'FORM.CONTACT_SELLER_LABEL'
  },
  NAME: {
    NAME: 'name',
    LABEL: 'COMMON.YOUR_NAME',
    PLACEHOLDER: 'FORM.CONTACT_NAME_LABEL',
    ERROR: 'FORM.CONTACT_NAME_TEXT_ERROR'
  },
  EMAIL: {
    NAME: 'email',
    LABEL: 'COMMON.YOUR_EMAIL',
    PLACEHOLDER: 'FORM.EMAIL_LABEL',
    ERROR: 'FORM.EMAIL_TEXT_ERROR'
  },
  ZIPCODE: {
    NAME: 'zipCode',
    LABEL: 'FORM.CONTACT_POSTAL_CODE_LABEL',
    PLACEHOLDER: 'FORM.CONTACT_POSTAL_CODE_LABEL',
    ERROR: 'FORM.ZIPCODE_TEXT_ERROR'
  },
  TARGET_BUYER: {
    NAME: 'targetBuyer',
    ERROR: 'Selecciona una opción'
  },
  PHONE: {
    NAME: 'phone',
    LABEL: 'COMMON.YOUR_PHONE',
    PLACEHOLDER: 'FORM.CONTACT_PHONE_LABEL',
    ERROR: 'FORM.CONTACT_PHONE_TEXT_ERROR'
  },
  TERMS_AND_CONDITIONS: {
    NAME: 'terms_and_conditions',
    LABEL: 'FORM.LEGAL_CHECKBOX_LABEL',
    ERROR: 'FORM.LEGAL_TEXT_ERROR'
  },
  PLATE: {
    NAME: 'plate',
    PLACEHOLDER: 'Matrícula del coche'
  },
  ENABLE_ALERTS: {
    NAME: 'enable_alerts',
    LABEL: 'Quiero recibir alertas de anuncios similares'
  }
}

const DEFAULT_FIELD_TEXT_VALUE = ''

const initialState = {
  captchaToken: '',
  hasBeenSubmitted: false,
  hasCaptcha: false,
  hasSuccessfulCaptcha: false,
  hasContacted: false,
  hasGenericError: false,
  isFinancingLead: false,
  isFormSubmitted: false,
  isLogged: false,
  isSellerBlocked: false,
  isWaitingForResponse: false,
  userHasBeenRegistered: false,
  autoGeneratedPassword: null,
  [FIELDS.MESSAGE.NAME]: {
    value: DEFAULT_FIELD_TEXT_VALUE,
    hasError: false
  },
  [FIELDS.NAME.NAME]: {
    value: DEFAULT_FIELD_TEXT_VALUE,
    hasError: true,
    isDisabled: false
  },
  [FIELDS.EMAIL.NAME]: {
    value: DEFAULT_FIELD_TEXT_VALUE,
    hasError: true,
    isDisabled: false
  },
  [FIELDS.PHONE.NAME]: {
    value: DEFAULT_FIELD_TEXT_VALUE,
    hasError: false,
    isDisabled: false
  },
  [FIELDS.ZIPCODE.NAME]: {
    value: DEFAULT_FIELD_TEXT_VALUE,
    hasError: false,
    isDisabled: false
  },
  [FIELDS.TARGET_BUYER.NAME]: {
    value: 'PRIVATES'
  },
  [FIELDS.TERMS_AND_CONDITIONS.NAME]: {
    value: false,
    hasError: false,
    isDisabled: false,
    isShown: true
  },
  [FIELDS.PLATE.NAME]: {
    value: DEFAULT_FIELD_TEXT_VALUE
  },
  [FIELDS.ENABLE_ALERTS.NAME]: {
    value: false
  }
}

const reducer = (state, action) => {
  switch (action.type) {
    case ACTION.FORM_HAS_CAPTCHA: {
      return {...state, hasCaptcha: true}
    }

    case ACTION.UPDATE_FIELD_VALUE: {
      const isEmailField = action.payload.field === FIELDS.EMAIL.NAME

      return {
        ...state,
        [action.payload.field]: {
          ...state[action.payload.field],
          value: action.payload.value
        },
        ...(isEmailField && {
          [FIELDS.TERMS_AND_CONDITIONS.NAME]: {
            ...state[FIELDS.TERMS_AND_CONDITIONS.NAME],
            isShown: true,
            value: false
          }
        })
      }
    }

    case ACTION.UPDATE_FORM_ERRORS: {
      const {
        [FIELDS.NAME.NAME]: hasNameError = false,
        [FIELDS.EMAIL.NAME]: hasEmailError = false,
        [FIELDS.PHONE.NAME]: hasPhoneError = false,
        [FIELDS.ZIPCODE.NAME]: hasZipCodeError = false,
        [FIELDS.TERMS_AND_CONDITIONS.NAME]: hasTermsAndConditionsError = false,
        hasGenericError
      } = action.payload

      return {
        ...state,
        hasGenericError,
        hasBeenSubmitted: true,
        isWaitingForResponse: false,
        [FIELDS.NAME.NAME]: {
          ...state[FIELDS.NAME.NAME],
          hasError: hasNameError
        },
        [FIELDS.EMAIL.NAME]: {
          ...state[FIELDS.EMAIL.NAME],
          hasError: hasEmailError
        },
        [FIELDS.PHONE.NAME]: {
          ...state[FIELDS.PHONE.NAME],
          hasError: hasPhoneError
        },
        [FIELDS.ZIPCODE.NAME]: {
          ...state[FIELDS.ZIPCODE.NAME],
          hasError: hasZipCodeError
        },
        [FIELDS.TERMS_AND_CONDITIONS.NAME]: {
          ...state[FIELDS.TERMS_AND_CONDITIONS.NAME],
          hasError: hasTermsAndConditionsError
        }
      }
    }

    case ACTION.SET_FIELDS_WITH_USER_LOGGED_DATA: {
      const {
        [FIELDS.MESSAGE.NAME]: messageValue = DEFAULT_FIELD_TEXT_VALUE,
        [FIELDS.NAME.NAME]: nameValue = DEFAULT_FIELD_TEXT_VALUE,
        [FIELDS.EMAIL.NAME]: emailValue = DEFAULT_FIELD_TEXT_VALUE,
        [FIELDS.PHONE.NAME]: phoneValue = DEFAULT_FIELD_TEXT_VALUE,
        [FIELDS.ZIPCODE.NAME]: zipCodeValue = DEFAULT_FIELD_TEXT_VALUE
      } = action.payload

      return {
        ...state,
        isLogged: true,
        [FIELDS.MESSAGE.NAME]: {
          ...state[FIELDS.NAME.NAME],
          hasError: false,
          value: messageValue
        },
        [FIELDS.NAME.NAME]: {
          ...state[FIELDS.NAME.NAME],
          hasError: false,
          value: nameValue,
          isDisabled: true
        },
        [FIELDS.EMAIL.NAME]: {
          ...state[FIELDS.EMAIL.NAME],
          hasError: false,
          value: emailValue,
          isDisabled: true
        },
        [FIELDS.PHONE.NAME]: {
          ...state[FIELDS.PHONE.NAME],
          hasError: false,
          value: phoneValue,
          isDisabled: Boolean(phoneValue)
        },
        [FIELDS.ZIPCODE.NAME]: {
          ...state[FIELDS.ZIPCODE.NAME],
          hasError: false,
          value: zipCodeValue
        },
        [FIELDS.TERMS_AND_CONDITIONS.NAME]: {
          ...state[FIELDS.TERMS_AND_CONDITIONS.NAME],
          hasError: false,
          value: true,
          isDisabled: true
        }
      }
    }

    case ACTION.SET_FIELDS_WITH_LAST_CONTACT_DETAILS: {
      const {
        [FIELDS.MESSAGE.NAME]: messageValue = DEFAULT_FIELD_TEXT_VALUE,
        [FIELDS.NAME.NAME]: nameValue = DEFAULT_FIELD_TEXT_VALUE,
        [FIELDS.EMAIL.NAME]: emailValue = DEFAULT_FIELD_TEXT_VALUE,
        [FIELDS.PHONE.NAME]: phoneValue = DEFAULT_FIELD_TEXT_VALUE,
        [FIELDS.ZIPCODE.NAME]: zipCodeValue = DEFAULT_FIELD_TEXT_VALUE,
        date
      } = action.payload

      const lastContactTime = new Date(date).getTime()
      const nowTime = Date.now()

      const millisecondsFromNowToLastContact = nowTime - lastContactTime
      const daysBetweenLastContactAndToday = fromMillisecondsToDays(millisecondsFromNowToLastContact)
      const hasContactedBeforeLastTwoWeeks = daysBetweenLastContactAndToday <= 14
      const isTermsAndConditionsChecked = hasContactedBeforeLastTwoWeeks

      return {
        ...state,
        [FIELDS.MESSAGE.NAME]: {
          ...state[FIELDS.NAME.NAME],
          hasError: false,
          value: messageValue
        },
        [FIELDS.NAME.NAME]: {
          ...state[FIELDS.NAME.NAME],
          value: nameValue
        },
        [FIELDS.EMAIL.NAME]: {
          ...state[FIELDS.EMAIL.NAME],
          value: emailValue
        },
        [FIELDS.PHONE.NAME]: {
          ...state[FIELDS.PHONE.NAME],
          value: phoneValue
        },
        [FIELDS.ZIPCODE.NAME]: {
          ...state[FIELDS.ZIPCODE.NAME],
          value: zipCodeValue
        },
        [FIELDS.TERMS_AND_CONDITIONS.NAME]: {
          ...state[FIELDS.TERMS_AND_CONDITIONS.NAME],
          value: isTermsAndConditionsChecked
        }
      }
    }

    case ACTION.USER_HAS_CONTACTED: {
      return {
        ...state,
        hasContacted: true,
        isWaitingForResponse: false,
        messageContactId: action.payload?.messageContactId
      }
    }

    case ACTION.DISABLE_FINANCING_LEAD: {
      return {...state, isFinancingLead: false}
    }
    case ACTION.ENABLE_FINANCING_LEAD: {
      return {...state, isFinancingLead: true}
    }

    case ACTION.USER_HAS_SUBMITTED: {
      return {...state, isWaitingForResponse: true}
    }

    case ACTION.USER_HAS_SUCCESSFUL_CAPTCHA: {
      const {captchaToken} = action.payload
      return {...state, hasSuccessfulCaptcha: true, captchaToken}
    }

    case ACTION.FORM_HAS_CONTACT_ERROR: {
      return {
        ...state,
        isWaitingForResponse: false,
        hasGenericError: true
      }
    }

    case ACTION.SET_IS_FORM_SUBMITTED: {
      const {isFormSubmitted} = action.payload
      return {...state, isFormSubmitted}
    }

    case ACTION.SET_IS_SELLER_BLOCKED: {
      const {isSellerBlocked} = action.payload
      return {...state, isSellerBlocked}
    }

    case ACTION.SET_AUTH_BEFORE_LEAD_RESULT: {
      const {userHasBeenRegistered, autoGeneratedPassword} = action.payload
      return {...state, userHasBeenRegistered, autoGeneratedPassword}
    }
  }
}

function fromMillisecondsToDays(time) {
  const seconds = time / 1000
  const hours = seconds / 3600
  const days = hours / 24

  return days
}

export {FIELDS, initialState, reducer}
